import type { ProgramEvent } from 'models';
import { EventActionsSocial } from '../../components';

type P = {
  authorId?: string;
  event: ProgramEvent;
};

const ProgramEventRsvpStatus = ({ authorId, event }: P) => {
  const { currentUserRsvp, status } = event;

  if (status === 'draft' || currentUserRsvp === 'pending') {
    return null;
  }

  return <EventActionsSocial authorId={authorId} event={event} type="link-secondary" view="header" />;
};

export default ProgramEventRsvpStatus;
